"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsModule = void 0;
const common_1 = require("../../../common");
__exportStar(require("./types"), exports);
/**
 * Scan analytics.
 *
 * Every per-code call takes an IANA time zone. Buckets are computed in Postgres
 * in that zone rather than in UTC and relabelled client-side — "scans today"
 * means the customer's today, and a UTC day boundary puts an evening scan in
 * Toronto onto the wrong date.
 */
class AnalyticsModule extends common_1.APIModule {
    constructor(client) {
        super(client, '/constellations');
    }
    getScanSummary(constellationId, timeZone) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                `${constellationId}/analytics/summary?tz=${encodeURIComponent(timeZone)}`,
            ]);
            const response = yield this.client.get(endpoint);
            return response.data;
        });
    }
    getHourlyScans(constellationId, timeZone) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                `${constellationId}/analytics/hourly?tz=${encodeURIComponent(timeZone)}`,
            ]);
            const response = yield this.client.get(endpoint);
            return response.data;
        });
    }
    getDailyScans(constellationId, timeZone, days) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                `${constellationId}/analytics/daily?tz=${encodeURIComponent(timeZone)}&days=${days}`,
            ]);
            const response = yield this.client.get(endpoint);
            return response.data;
        });
    }
    getScanPlaces(constellationId, days, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                `${constellationId}/analytics/locations?days=${days}&limit=${limit}`,
            ]);
            const response = yield this.client.get(endpoint);
            return response.data;
        });
    }
    getOrganizationScanTotals(organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            /* Not under this module's `/constellations` base — it is organization
               scoped, and the whole point is one request instead of one per code. */
            const response = yield this.client.get(`${this.client.options.apiUrl}/organizations/${organizationId}/analytics/scan-totals`);
            return response.data;
        });
    }
}
exports.AnalyticsModule = AnalyticsModule;
